const codes = [
    30207, // 已评
];

const alertHasCode = (code) => {
    const result = codes.join(',').indexOf(code) > -1;
    return result;
};

export { alertHasCode as default };
